import { useId } from "react";

export const useResolvedId = (id?: string) => {
	const internalId = useId();

	return id ?? internalId;
};
